import { useQuery } from '@pinia/colada';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { SyndicationPlatformDto } from '../dtos/syndication-platforms-response.dto.interface';
import propertyListingService from '../services/property-listing.service';

export function getPropertySyndicationPlatformsQueryKey(propertyId: string) {
  return ['property', propertyId, 'syndication-platforms'];
}

export function usePropertySyndicationPlatformsQuery() {
  const route = useRoute();
  const propertyId = computed(() => route.params.propertyId as string);

  const query = useQuery({
    key: () => getPropertySyndicationPlatformsQueryKey(propertyId.value),
    query: async () => {
      const response = await propertyListingService.getSyndicationPlatforms(propertyId.value);
      return response.data;
    },
  });

  // Flatten the nested platforms structure
  const platforms = computed<SyndicationPlatformDto[]>(() => {
    if (!query.data.value?.platforms || !Array.isArray(query.data.value.platforms)) {
      return [];
    }

    return query.data.value.platforms.flatMap((platformGroup) => platformGroup?.status?.platforms || []);
  });

  // Top-level syndication group names (e.g. 'zillow', 'zumper', 'apartments-dot-com').
  // Source of truth for which platforms a property is currently syndicated to.
  const enabledPlatforms = computed<string[]>(() => {
    if (!query.data.value?.platforms || !Array.isArray(query.data.value.platforms)) {
      return [];
    }

    return query.data.value.platforms.map((platformGroup) => platformGroup.name);
  });

  return {
    ...query,
    platforms,
    enabledPlatforms,
  };
}
